module.exports = __webpack_public_path__ + "img/490.238043bc.png";